// src/hooks/useOnlineStatus.js
//
// Returns the real-time online/offline status for a given userId.
// Returns false (offline) when userId is null/undefined or when the status
// has not yet been received from the server.
//
// Usage:
//   const isOnline = useOnlineStatus(selectedUser?.id);

import { useSelector } from 'react-redux';

export function useOnlineStatus(userId) {
  return useSelector(
    (state) => (userId ? (state.onlineStatus[userId] ?? false) : false)
  );
}